import { ADVISOR_PROSPECTS_RECEIVED, ADVISOR_PROSPECTS_UPDATED, ADVISOR_PROSPECTS_DELETED, ADVISOR_PROSPECT_NOTE_UPDATED, ADVISOR_PROSPECT_STATUS_UPDATED, ADVISOR_PROSPECT_CLAIMED } from './types'
export default function prospects(state = [], action = {}){ 
  switch (action.type) {
    case ADVISOR_PROSPECTS_RECEIVED:
        return action.data
    case ADVISOR_PROSPECTS_UPDATED:
      state = state.map((item, index) => {
        if(item.id === action.data.id) {
          return action.data 
        }
        return item 
      }) 
      return state
    case ADVISOR_PROSPECT_NOTE_UPDATED:
      state = state.map((item, index) => {
        if(item.id === action.data.id) {
          return { ...item, assignedNotes: action.data.note, assignedStatus: action.data.status, assignedStatusDate: action.data.updated}
        }
        return item 
      }) 
      return state
    case ADVISOR_PROSPECT_STATUS_UPDATED:
      state = state.map((item, index) => {
        if(item.id === action.data.id) {
          return {  ...item, assignedStatus: action.data.status, assignedStatusDate: action.data.updated}
        }
        return item 
      }) 
      return state
    case ADVISOR_PROSPECTS_DELETED:
      return state.filter(n => n.id !== action.data) 
    default:
      return state;
  }
}
